import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, Avatar } from '@mui/material';

interface SectionCardProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  color?: string;
}

// Carte d'en-tête standardisée pour toutes les sections du module KYC —
// remplace les vieux fieldset/legend pour un rendu plus soigné et cohérent.
export default function SectionCard({ icon, title, subtitle, action, children, color = '#124b7a' }: SectionCardProps) {
  return (
    <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, borderColor: 'grey.300', boxShadow: '0 1px 2px rgba(16,24,40,0.05)' }}>
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: color, width: 36, height: 36 }}>{icon}</Avatar>}
        title={title}
        subheader={subtitle}
        action={action}
        titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600, color: 'text.primary' }}
        subheaderTypographyProps={{ variant: 'caption' }}
        sx={{ pb: subtitle ? 0.5 : 1.5, borderBottom: '1px solid', borderColor: 'grey.100', mb: 1.5 }}
      />
      <CardContent sx={{ pt: 0.5 }}>{children}</CardContent>
    </Card>
  );
}
